module.exports = __webpack_public_path__ + "static/media/Top10_hydroponic_crops_img.5c952f66.webp";